import {Flex} from 'antd';
import {ReactElement} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {getReviewConditionHistoryLocaleKey} from '../../../../../../../../service/reviews/reviews-condition-history-helper';
import {ReviewHistoryDataType} from '../../../../../../../../service/reviews/reviews-history';

type PropsType = {
    formattedDate: string | null;
    formattedTime: string | null;
    log: ReviewHistoryDataType;
};

export function HistoryConditionLog(props: PropsType): ReactElement | null {
    const {formattedDate, formattedTime, log} = props;

    const conditionLocaleKey = getReviewConditionHistoryLocaleKey(log.field, log.oldValue, log.newValue);

    if (!conditionLocaleKey) {
        return null;
    }

    return (
        <Flex gap={4} vertical>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Text lighter stringKey={conditionLocaleKey} />
        </Flex>
    );
}
